module.exports = __webpack_public_path__ + "static/media/arrow-button-left-off-2.c21e1c01.svg";